module.exports = __webpack_public_path__ + "img/45eca25.jpg";